
const contentview = [{"key":"contentview.title","string":"Ihre hinzugefügten Inhalte"},{"key":"contentview.add_content_button","string":"Inhalt hinzufügen"},{"key":"contentview.no_content_added","string":"Sie haben noch keine Inhalte hinzugefügt."},{"key":"contentview.table.title","string":"Titel"},{"key":"contentview.table.author","string":"Autor(en)"},{"key":"contentview.table.year","string":"Jahr"},{"key":"contentview.full_text","string":"Gesamten Inhalt ansehen"}]

export default contentview



// WEBPACK FOOTER //
// ./src/i18n/de/addcontent/contentview.js